export const REVISION_TYPES = [
  'main',
  'communication',
  'configuration',
  'database',
  'career',
  'forms',
  'extranet',
  'group',
] as const;

export type RevisionType = (typeof REVISION_TYPES)[number];

export interface FetchOptions extends Omit<RequestInit, 'headers'> {
  groupId: string;
  headers?: Record<string, string>;
}

export class ApiError extends Error {
  constructor(
    public message: string,
    public status: number,
    public response?: Response,
    // Parsed error body, when the backend returned JSON
    public data?: unknown
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
